import React, { useState, useEffect } from "react";
import { array, func, bool } from "prop-types";
import ArrowDown from "../../../../assets/icons/arrowDown";
import CheckboxIcon from "../../../../assets/icons/CheckboxIcon";
import UncheckedIcon from "../../../../assets/icons/UncheckedIcon";
import { Icon } from "../../atoms/icon";
import { FilterPills } from "../filter-pills";
import "./city-filter.m.css";

export const CityFilter = ({
  availableCities = [],
  selectedCities = [],
  onCitySelect,
  onCityRemove,
  onClearAll,
  onPageReset,
  isMobile = false,
  allowMultiSelect = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCitySelect = (city) => {
    if (isMobile) {
      const isSelected = selectedCities.includes(city);
      if (isSelected) {
        if (onCityRemove) {
          onCityRemove(city);
        }
      } else {
        if (onCitySelect) {
          onCitySelect(city);
        }
      }
    } else {
      if (onCitySelect) {
        onCitySelect(city);
      }
      setIsOpen(false);
    }

    if (onPageReset) {
      onPageReset(1);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleReset = () => {
    if (onClearAll) {
      onClearAll();
    }
    if (isMobile) {
      setIsOpen(false);
    }

    if (onPageReset) {
      onPageReset(1);
    }
  };

  const handleClickOutside = (e) => {
    if (!e.target.closest('[data-city-filter]')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen && !isMobile) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isOpen, isMobile]);

  useEffect(() => {
    if (isOpen && isMobile) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = 'unset';
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.body.classList.remove("modal-open");
    };
  }, [isOpen, isMobile]);

  return (
    <div styleName="city-filter" data-city-filter {...props}>
      <button
        styleName="filter-button"
        onClick={handleToggleDropdown}
        type="button"
      >
        <span styleName="filter-text">Filter by city</span>
        <div styleName="filter-icon" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
          <ArrowDown />
        </div>
      </button>

      {isOpen && availableCities?.length > 0 && (
        <div styleName={isMobile ? "mobile-filter-modal" : "dropdown-menu"}>
          {isMobile ? (
            <div styleName="mobile-filter-content">
              <div styleName="mobile-filter-header">
                <div styleName="mobile-filter-title">
                  <h3>Filter by city</h3>
                </div>
                <button
                  type="button"
                  styleName="close-button"
                  onClick={handleClose}
                  aria-label="Close filter"
                >
                  <Icon name="close" size="xsmall" />
                </button>
              </div>

              <div styleName="mobile-filter-body">
                {selectedCities.length > 0 && (
                  <div styleName="mobile-filter-pills-section">
                    <FilterPills
                      selectedCities={selectedCities}
                      onRemoveFilter={(city) => {
                        onCityRemove(city);
                        if (onPageReset) {
                          onPageReset(1);
                        }
                      }}
                      onClearAll={() => {
                        onClearAll();
                        if (onPageReset) {
                          onPageReset(1);
                        }
                      }}
                    />
                  </div>
                )}

                <div styleName="mobile-cities-list">
                  {availableCities.map((city) => {
                    const isSelected = selectedCities.includes(city);
                    return (
                      <div
                        key={city}
                        styleName={`mobile-filter-item ${isSelected ? 'selected' : ''}`}
                        onClick={() => handleCitySelect(city)}
                      >
                        {isSelected ? <CheckboxIcon /> : <UncheckedIcon />}
                        <span styleName="city-label">{city}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div styleName="mobile-filter-footer">
                <button
                  type="button"
                  styleName="reset-button"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  type="button"
                  styleName="apply-button"
                  onClick={handleClose}
                >
                  Apply
                </button>
              </div>
            </div>
          ) : (
            availableCities.map((city) => {
              const isSelected = selectedCities.includes(city);
              return (
                <button
                  key={city}
                  type="button"
                  styleName={`dropdown-item ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleCitySelect(city)}
                >
                  {isSelected ? <CheckboxIcon /> : <UncheckedIcon />}
                  {city}
                </button>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

CityFilter.propTypes = {
  availableCities: array,
  selectedCities: array,
  onCitySelect: func,
  onCityRemove: func,
  onClearAll: func,
  onPageReset: func,
  isMobile: bool,
  allowMultiSelect: bool
};